export const JEWELLERY_TYPE_OPTIONS = [
  { value: "all_fine", label: "All Fine Jewellery" },
  { value: "9_carat", label: "9-Carat Jewellery" },
];

export function labelForJewelleryType(value) {
  if (!value) return "—";
  const opt = JEWELLERY_TYPE_OPTIONS.find((o) => o.value === value);
  return opt ? opt.label : String(value);
}
